import { decimalSeparator, groupSeparator } from "@/lib/formatting";

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function normalizeCashInput(value: string): string {
  const decimalOrGroup = `${escapeRegExp(decimalSeparator)}${escapeRegExp(groupSeparator)},.`;
  const cleaned = value.replace(new RegExp(`[^\\d${decimalOrGroup}]`, "g"), "");

  if (!cleaned) {
    return "";
  }

  const lastDot = cleaned.lastIndexOf(".");
  const lastComma = cleaned.lastIndexOf(",");
  const lastLocaleDecimal = cleaned.lastIndexOf(decimalSeparator);
  const decimalIndex = Math.max(lastDot, lastComma, lastLocaleDecimal);

  const integerRaw = decimalIndex === -1 ? cleaned : cleaned.slice(0, decimalIndex);
  const fractionRaw = decimalIndex === -1 ? "" : cleaned.slice(decimalIndex + 1);
  const intPart = integerRaw.replace(/\D/g, "").replace(/^0+(?=\d)/, "");

  if (decimalIndex === -1) {
    return intPart;
  }

  const fraction = fractionRaw.replace(/\D/g, "").slice(0, 2);
  return `${intPart || "0"}.${fraction}`;
}

export function normalizeChipInput(value: string): string {
  const digits = value.replace(/\D/g, "");
  return digits.replace(/^0+(?=\d)/, "");
}

export function sanitizeChipInput(value: string): string {
  return value.replace(/\D/g, "");
}

export function sanitizeCashEditInput(value: string): string {
  const cleaned = value.replace(/[^\d.,]/g, "");

  if (!cleaned) {
    return "";
  }

  const lastDot = cleaned.lastIndexOf(".");
  const lastComma = cleaned.lastIndexOf(",");
  const decimalIndex = Math.max(lastDot, lastComma);

  const intPart = (decimalIndex === -1 ? cleaned : cleaned.slice(0, decimalIndex))
    .replace(/\D/g, "")
    .replace(/^0+(?=\d)/, "");

  if (decimalIndex === -1) {
    return intPart;
  }

  const fraction = cleaned.slice(decimalIndex + 1).replace(/\D/g, "").slice(0, 2);
  return `${intPart || "0"}${decimalSeparator}${fraction}`;
}
